import React from "react";

import NavbarBottom from "../NavbarBottom";

import Page1 from "./Pages/Page1";
import Page2 from "./Pages/Page2";

class StrengthsActivity extends React.Component {
  state = {
    pageNum: 1,
    maxPageNum: 2,
  };

  moveForward = () => {
    console.log(this.state.pageNum);

    let page = this.state.pageNum;
    page = page < this.state.maxPageNum ? page + 1 : page;
    this.setState({
      pageNum: page,
    });
    console.log(this.state.pageNum);
  };

  moveBackward = () => {
    let page = this.state.pageNum;
    page = page > 1 ? page - 1 : page;
    this.setState({
      pageNum: page,
    });
    console.log(this.state.pageNum);
  };
  renderSwitch(page) {
    switch (page) {
      case 1:
        return <Page1 />;

      default:
        return <Page2 />;
    }
  }

  render() {
    return (
      <div style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        {this.renderSwitch(this.state.pageNum)}

        <NavbarBottom
          moveForwardHandler={this.moveForward}
          moveBackwardHandler={this.moveBackward}
          title="Strengths Activity"
        >
          <div
            className="dropdown-item"
            onClick={() =>
              this.setState({
                pageNum: 1,
              })
            }
          >
            Understanding Strengths
          </div>
          <div
            className="dropdown-item"
            onClick={() =>
              this.setState({
                pageNum: 2,
              })
            }
          >
            What are your strengths?
          </div>
        </NavbarBottom>
      </div>
    );
  }
}

export default StrengthsActivity;
